const ID_RELIC_KEY = "id_relic";
const NEXT_ROUTE_KEY = "next_route";

export const getRelicId = () => {
  return window.localStorage.getItem(ID_RELIC_KEY);
};

export const saveRelicId = (relicId) => {
  window.localStorage.setItem(ID_RELIC_KEY, relicId);
};

export const destroyRelicId = () => {
  window.localStorage.removeItem(ID_RELIC_KEY);
};

export const getNextRoute = () => {
  return window.localStorage.getItem(NEXT_ROUTE_KEY);
};

export const saveNextRoute = (nextRoute) => {
  window.localStorage.setItem(NEXT_ROUTE_KEY, nextRoute);
};

export const destroyNextRoute = () => {
  window.localStorage.removeItem(NEXT_ROUTE_KEY);
};

export default {
  getRelicId,
  saveRelicId,
  destroyRelicId,
  getNextRoute,
  saveNextRoute,
  destroyNextRoute,
};
